import styled, { css } from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
/**
 * Mixin that provides a set of unified border styles for usage in various
 * components that require visual dividers
 *
 * @param {LogicalOrientation} orientation
 */
export function injectDividerBorderStyle(orientation) {
    return css `
    border-${orientation}-width: 1px;
    border-${orientation}-style: solid;
    border-${orientation}-color: ${(props) => props.theme.colors.ui.divider.primary};
  `;
}
export const StyledDivider = styled.hr `
  height: 0;
  margin: 0;

  border: none;
  ${injectDividerBorderStyle('block-start')}

  ${injectSpacing('margin')}
`;
//# sourceMappingURL=Divider.styles.js.map